import { setOnlineStatus } from "@/store/slices/networkSlice";
import { store } from "@/store/store";

const TEST_URL = `${process.env.REACT_APP_BASE_URL}/health`;

export function startNetworkMonitoring() {
  async function checkInternetConnection() {
    const previousState = store.getState().network.isOnline;

    if (!navigator.onLine) {
      if (previousState) store.dispatch(setOnlineStatus(false));
      return false;
    }

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);
      await fetch(TEST_URL, { method: "GET", signal: controller.signal });
      clearTimeout(timeoutId);

      if (!previousState) store.dispatch(setOnlineStatus(true));
      return true;
    } catch (error) {
      if (previousState) store.dispatch(setOnlineStatus(false));
      return false;
    }
  }

  //Check Immediately on Page Load
  checkInternetConnection();

  //Check every 5 seconds after that
  setInterval(checkInternetConnection, 5000);
}
